import React, { useEffect, useReducer } from 'react';
import { Badge, Button } from '@themesberg/react-bootstrap';
import { useCookies } from 'react-cookie';
import { useHistory, useLocation } from 'react-router-dom';
import { getAllGames } from '../../../controller/api/game';
import FilterForm from './partials/FilterForm';
import Summary from './partials/Summary';
import Table from './partials/Table';
import './reward.css';

export const Context = React.createContext(null);

const statusFilters = [
  ['all', 'Tất cả', 'primary'],
  ['unpaid', 'Chưa trả thưởng', 'warning'],
  ['paid', 'Đã trả thưởng', 'success']
];

const createInitialState = search => ({
  filter: {
    from: new Date(),
    to: new Date(),
    phone: '',
    gameScope: new URLSearchParams(search).get('tab') === 'other' ? 'other' : 'keno',
    gameId: '',
    paymentStatus: 'all',
    minReward: '',
    maxReward: '',
    page: 0,
    sortBy: 'createdAt',
    sortDirection: 'desc'
  },
  data: { list: [], total: 0, totalPage: 0 },
  summary: { gross: 0, tax: 0, fee: 0, net: 0, count: 0, unPaided: 0, games: {}, statuses: {} },
  games: [],
  isPaying: false,
  isFilterLoading: false,
  filterPressCount: 0
});

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: { ...state.filter, ...action.payload, page: 0 },
        isFilterLoading: true,
        filterPressCount: state.filterPressCount + 1
      };
    case 'PAY_REWARD_ALL':
      return { ...state, isPaying: !state.isPaying };
    case 'UPDATE_DATA':
      return { ...state, data: { ...action.payload } };
    case 'UPDATE_PAGE':
      return { ...state, filter: { ...state.filter, page: action.payload } };
    case 'SET_FILTER_LOADING':
      return { ...state, isFilterLoading: action.payload };
    case 'SET_GAMES':
      return { ...state, games: action.payload || [] };
    case 'SET_SUMMARY':
      return { ...state, summary: { ...state.summary, ...(action.payload || {}) } };
    case 'REFRESH':
      return { ...state, isFilterLoading: true, filterPressCount: state.filterPressCount + 1 };
    default:
      return state;
  }
};

export default function Reward() {
  const location = useLocation();
  const history = useHistory();
  const [cookies] = useCookies(['lottmekong']);
  const [state, dispatch] = useReducer(reducer, location.search, createInitialState);

  useEffect(() => { document.title = 'Trúng thưởng'; }, []);

  useEffect(() => {
    let active = true;
    getAllGames(cookies.lottmekong)
      .then(response => { if (active && response?.data) dispatch({ type: 'SET_GAMES', payload: response.data }); })
      .catch(error => console.error('Error loading games:', error));
    return () => { active = false; };
  }, [cookies.lottmekong]);

  const selectTab = gameScope => {
    if (gameScope === state.filter.gameScope) return;
    const query = new URLSearchParams(location.search);
    query.set('tab', gameScope);
    history.replace({ pathname: location.pathname, search: `?${query.toString()}` });
    dispatch({ type: 'SUBMIT_FILTER', payload: { gameScope, gameId: '' } });
  };

  return (
    <Context.Provider value={{ state, dispatch }}>
      <div className="reward-page">
        <div className="reward-heading">
          <h4 className="mb-0">Trúng thưởng</h4>
          <div className="reward-game-tabs" role="group" aria-label="Nhóm trò chơi">
            {[['keno', 'Keno'], ['other', 'Vé khác']].map(([scope, label]) => (
              <button
                type="button"
                key={scope}
                className={state.filter.gameScope === scope ? 'active' : ''}
                aria-pressed={state.filter.gameScope === scope}
                onClick={() => selectTab(scope)}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        <FilterForm />
        <Summary />

        <div className="reward-status-tabs" role="group" aria-label="Trạng thái trả thưởng">
          {statusFilters.map(([id, label, color]) => (
            <Button
              key={id}
              size="sm"
              variant={state.filter.paymentStatus === id ? 'primary' : 'outline-light'}
              aria-pressed={state.filter.paymentStatus === id}
              onClick={() => {
                if (state.filter.paymentStatus !== id) dispatch({ type: 'SUBMIT_FILTER', payload: { paymentStatus: id } });
              }}
            >
              {label}
              <Badge
                bg={state.filter.paymentStatus === id ? 'light' : color}
                text={state.filter.paymentStatus === id ? 'dark' : undefined}
                className="ms-2"
              >
                {Number(state.summary.statuses?.[id] || 0).toLocaleString('vi-VN')}
              </Badge>
            </Button>
          ))}
        </div>

        <Table />
      </div>
    </Context.Provider>
  );
}
